import momentTimezone from 'moment-timezone';
import React, {memo, useContext, useMemo} from 'react';
import {ThemeContext} from '../../apiContexts';
import LoadingBar from '../../components/loadingBar';
import ReactTable from '../../components/reactTable';
import {convertDistanceTo, convertSpeedTo, convertVolumeTo, nomenclatureDistance, nomenclatureSpeedOf, nomenclatureVolume} from '../../helpers/conversions';
import {durationFormat} from '../../helpers/date';
import {getColumnWidth} from '../../helpers/report';
import {ButtomStyled} from '../../styles';
import {Header, ListStyle} from './styles';

const TripList = ({
  className,
  data,
  timezone,
  onSelect,
  speedUnit,
  distanceUnit,
  volumeUnit,
  loading,
  ...props
}) => {
  const theme = useContext(ThemeContext);

  const columns = useMemo(
      () => [
        {
          Header: 'Nome',
          accessor: 'deviceName',
          minWidth: 200,
          width: getColumnWidth(data, 'deviceName', 'Nome'),
        },
        {
          Header: 'Hora inicial',
          accessor: 'startTime',
          Cell: ({cell: {value}}) =>
            momentTimezone(value)
                .tz(timezone)
                .format('DD/MM/YYYY [-] HH:mm:ss'),
          minWidth: 200,
        },
        {
          Header: 'Início do odômetero',
          accessor: 'startOdometer',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertDistanceTo(value, distanceUnit)).toFixed(2) ||
            0} ${nomenclatureDistance(distanceUnit)}`,
        },
        {
          Header: 'Endereço inicial',
          accessor: 'startAddress',
          Cell: ({cell: {value}}) => value || '-',
          minWidth: 150,
          width: getColumnWidth(data, 'startAddress', 'Endereço inicial'),
        },
        {
          Header: 'Hora final',
          accessor: 'endTime',
          Cell: ({cell: {value}}) =>
            momentTimezone(value)
                .tz(timezone)
                .format('DD/MM/YYYY [-] HH:mm:ss'),
          minWidth: 200,
        },
        {
          Header: 'Fim do odômetero',
          accessor: 'endOdometer',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertDistanceTo(value, distanceUnit)).toFixed(2) ||
            0} ${nomenclatureDistance(distanceUnit)}`,
        },
        {
          Header: 'Endereço final',
          accessor: 'endAddress',
          Cell: ({cell: {value}}) => value || '-',
          minWidth: 150,
          width: getColumnWidth(data, 'endAddress', 'Endereço final'),
        },
        {
          Header: 'Distância',
          accessor: 'distance',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertDistanceTo(value, distanceUnit)).toFixed(2) ||
            0} ${nomenclatureDistance(distanceUnit)}`,
        },
        {
          Header: 'Velocidade Média',
          accessor: 'averageSpeed',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertSpeedTo(value, speedUnit)).toFixed(1) ||
            0} ${nomenclatureSpeedOf(speedUnit)}`,
        },
        {
          Header: 'Velocidade Máxima',
          accessor: 'maxSpeed',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertSpeedTo(value, speedUnit)).toFixed(1) ||
            0} ${nomenclatureSpeedOf(speedUnit)}`,
        },
        {
          Header: 'Duração',
          accessor: 'duration',
          Cell: ({cell: {value}}) => durationFormat(value, 'H [h] mm [m]'),
        },
        {
          Header: 'Gasto de Combustível',
          accessor: 'spentFuel',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertVolumeTo(value, volumeUnit)).toFixed(1) ||
            0} ${nomenclatureVolume(volumeUnit)}`,
        },
        {
          Header: 'Motorista',
          accessor: 'driverUniqueId',
          minWidth: 150,
          width: getColumnWidth(data, 'driverUniqueId', 'Motorista'),
        },
      ],
      [data],
  );

  const selectItem = (props) => onSelect(props);

  return (
    <ListStyle theme={theme} className="custom-shadow-2">
      <Header>
        <h5>Histório de Viagens</h5>
        <ButtomStyled
          theme={theme}
          outline
          className="custom-shadow custom-border btn-theme mb-3"
        >
          <span>Selecionar dispositivo</span>
        </ButtomStyled>
      </Header>
      {loading ? (
        <LoadingBar />
      ) : (
        <ReactTable data={data} columns={columns} selectItem={selectItem} />
      )}
    </ListStyle>
  );
};

export default memo(TripList);
